<template>
  <div
      class="min-w-screen min-h-screen bg-slate-100 flex flex-col justify-center items-center p-5 lg:p-20 overflow-hidden relative"
  >
    <div
        class="min-h-full md:w-1/2 rounded-3xl bg-white shadow-xl p-5 sm:p-10 text-gray-800 relative items-center text-left"
    >
      <div class="w-full md:w-full">
        <div class="text-gray-600 font-light">
          <form class="flex flex-col gap-y-10" @submit.prevent="submit">
            <h1 class="text-center text-3xl md:text-4xl xl:text-5xl text-slate-400">
              Ingresa tu nueva contraseña
            </h1>
            <div class="flex-row flex-wrap flex gap-5">
              <div class="flex flex-col md:flex-row grow gap-y-5">
                <label style="min-width:130px; max-width: 130px;" class="font-bold" for="new_password">Nueva
                  contraseña:</label>
                <input
                    class="w-full"
                    v-model="form.password"
                    type="password"
                    id="new_password"
                    required
                    autofocus
                />
              </div>
              <div class="flex flex-col md:flex-row grow gap-y-5">
                <label style="min-width:130px; max-width: 130px;" class="font-bold" for="new_password_confirmation"
                >Confirma tu contraseña:</label
                >
                <input
                    class="w-full"
                    v-model="form.confirm"
                    type="password"
                    id="new_password_confirmation"
                    required
                    autofocus
                />
              </div>
            </div>
            <ul class="space-y-1 text-red-500 list-inside dark:text-red-400" v-if="!contrasenaValida">
              <li class="flex items-center" v-for="(mensaje, index) in mensajesError" :key="index">
                <svg class="w-4 h-4 mr-1.5 text-red-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                      clip-rule="evenodd"
                  ></path>
                </svg>
                <span v-text="mensaje"></span>
              </li>
            </ul>
            <button class="form__btn z-10" style="width: 100%;" type="submit">
              Actualizar contraseña
            </button>
          </form>
          <button v-if="validateUser"
              class="text-lg font-light outline-none focus:outline-none transform transition-all hover:scale-110 text-yellow-500 hover:text-yellow-600 mr-5"
          >
            <i class="mdi mdi-arrow-left mr-2"></i>
            <router-link to="/">Volver</router-link>
          </button>
        </div>
      </div>
      <div class="w-full md:w-1/2 text-center"></div>
    </div>
    <div
        class="w-64 md:w-96 h-96 md:h-full bg-green-600 bg-opacity-30 absolute -top-64 md:-top-96 right-20 md:right-32 rounded-full pointer-events-none -rotate-45 transform"
    ></div>
    <div
        class="w-96 h-full bg-red-600 bg-opacity-20 absolute z-1 -bottom-96 right-64 rounded-full pointer-events-none -rotate-45 transform"
    ></div>
  </div>
</template>

<script>
import {useRoute} from "vue-router";
import {useRouter} from "vue-router";
import {reactive, ref} from "vue";
import {swal} from "@/common/constants/variables";
import {generateTextError, useAPIRest, verifyHttpCode} from "@/common/constants";

export default {
  name: 'RecuperarContrasena_2',
  async setup() {
    const dataUser = ref(localStorage.getItem('user'));
    const userData = JSON.parse(dataUser.value);
    const validateUser = (userData != undefined && userData.first_login) ? false : true;
    const form = reactive({
      password: "",
      confirm: "",
    });
    let contrasenaValida = ref(true);
    let mensajesError = ref([]);
    const router = useRouter();
    const route = useRoute();
    const token = {token: route.params.rememberToken};
    const peticion = async () => {
      return await useAPIRest(process.env.VUE_APP_NEST_AUTH_REMEMBER_TOKEN, 'POST', undefined, token, undefined, 'application/json', 'include').then((resJSON) => {
        const {statusCode} = resJSON;
        delete resJSON.statusCode;
        const textoError = generateTextError(resJSON);
        if (verifyHttpCode(statusCode, 'success')) {
          if(resJSON["respuesta"] === false) router.push('/');
        }
        else swal.fire(textoError, '', 'error');
      });
    };
    await peticion();
    const submit = async () => {
      if (form.password !== form.confirm) {
        mensajesError.value = [];
        mensajesError.value.push("Las contraseñas no coinciden");
        contrasenaValida.value = false;
      } else contrasenaValida.value = true;
      if (contrasenaValida.value) {
        await useAPIRest(process.env.VUE_APP_NEST_AUTH_CHANGE_PASSWORD_TOKEN, 'PUT', undefined, {
          token: token.token,
          password: form.password,
        }, undefined, 'application/json', 'include').then((resJSON) => {
          const {statusCode} = resJSON;
          delete resJSON.statusCode;
          if (verifyHttpCode(statusCode, 'error')) {
            mensajesError.value = resJSON.message;
            contrasenaValida.value = false;
          } else {
            contrasenaValida.value = true;
            swal.fire(
                "Contraseña actualizada",
                "¡Tu contraseña fue actualizada exitosamente!",
                "success"
            ).then(() => router.push('/'));
          }
        });
      }
    };
    return {
      form,
      contrasenaValida,
      mensajesError,
      submit,
      validateUser,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/main.scss";

.form {
  width: 100%;

  &__group {
    &:not(:last-child) {
      margin-bottom: 2rem;
    }
  }

  &__input {
    height: 2rem;
    width: 100%;
    padding: 2rem 1rem;
    border-radius: 4px;
    color: $color__primary;
    border: 1px solid $color__secondary;

    &:focus,
    &:active {
      outline: none;
    }

    &:placeholder-shown,
    &::placeholder {
      color: $color__secondary;
    }
  }

  &__label {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    color: $color__primary;
  }

  &__btn {
    width: 150px;
    @include customBorder($color__primary, $color__secondary);
    color: $color__white;
    padding: 1rem;
    border-radius: 4px;
    margin-bottom: 1rem;

    cursor: pointer;
  }
}

.errorLogin {
  @include customBorder(#fbe6e1, $color__gray--dark);

  &__text {
    color: $color__gray--dark;
  }
}
</style>
